/* eslint-disable @typescript-eslint/no-explicit-any */
//START GENAI@GHCOPILOT
import { HandlerEvent } from 'post-robot';
import { ZodIssue } from 'zod';
import { error, ValidationError } from 'common/errors';
import { markEnd, markStart } from 'common/instrumentation';
import { VISA } from 'common/network-partners';
import { CommunicatorState, getState, saveApiResponseCache } from 'orch-communicator/store';
import { CompleteIdentityValidationData } from 'types/vsb-sdk/complete-identity-validation';
//END GENAI@GHCOPILOT

export default async function completeIdentityValidation(
  event: HandlerEvent<CompleteIdentityValidationData>
) {
  const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
  const inputData = { validationData: event.data.validationData };
  const otpProvider = getState().meta.otpProvider || VISA;

  try {
    /* START GENAI@GHCOPILOT */
    markStart(`vsb_complete_identity_validation_${otpProvider}`);
    const probeResponse = await vSDK[otpProvider].completeIdentityValidation(inputData);
    markEnd(`vsb_complete_identity_validation_${otpProvider}`);
    /* END GENAI@GHCOPILOT */
    const idToken = probeResponse.idToken;
    const communicatorState = getState() as CommunicatorState;

    const apiResponseCache = {
      ...communicatorState.srcSdks.apiResponseCache,
      completeIdentityValidation: idToken
    };

    saveApiResponseCache(apiResponseCache);

    return idToken;
    //START GENAI@GHCOPILOT
    //START GENAI@GHCOPILOT
    //START GENAI@GHCOPILOT
  } catch (e: any) {
    if (otpProvider === 'VISA') {
      //eslint-disable-next-line
      e = e.error;
    }

    if ('reason' in e && e.reason === 'CODE_INVALID') {
      throw error(
        'VALIDATION_DATA_INVALID',
        'The supplied "validationData" is invalid.',
        ' ' as any
      ) as ValidationError;
    } else if ('reason' in e && e.reason === 'CODE_EXPIRED') {
      throw error('VALIDATION_DATA_EXPIRED', 'The "validationData" is expired.', ' ' as any);
    } else if ('reason' in e && e.reason === 'VALDATA_MISSING') {
      throw error('VALIDATION_DATA_MISSING', 'The "validationData" parameter is missing.', [
        {
          message: 'Validation data should be a non empty string.',
          path: 'validationData'
        }
      ] as unknown as ZodIssue[]) as ValidationError;
    } else if ('reason' in e && e.reason === 'ACCT_INACCESSIBLE') {
      throw error(
        'ACCT_INACCESSIBLE',
        'The user account exists but is not currently accessible.',
        ' ' as any
      ) as ValidationError;
    } else if ('reason' in e && e.reason === 'RETRIES_EXCEEDED') {
      throw error(
        'RETRIES_EXCEEDED',
        'The limit for the number of retries exceeded.',
        ' ' as any
      ) as ValidationError;
    }
    //END GENAI@GHCOPILOT

    throw error('UNKNOWN_ERROR', 'Unknown error.', ' ' as any);
    //END GENAI@GHCOPILOT
    //END GENAI@GHCOPILOT
  }
}
